import { useState, useEffect } from "react";

const navLinks = [
  { label: "Início", href: "#hero" },
  { label: "Sobre", href: "#sobre" },
  { label: "Serviços", href: "#servicos-faciais" },
  { label: "Sobrancelhas", href: "#servicos-sobrancelhas" },
  { label: "Depoimentos", href: "#depoimentos" },
  { label: "Contato", href: "#contato" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 40);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    if (mobileOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileOpen]);

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
          scrolled
            ? "bg-background-950/90 backdrop-blur-md border-b border-primary-500/15"
            : "bg-transparent border-b border-transparent"
        }`}
      >
        <div className="relative w-full px-6 md:px-10 h-20 md:h-24 flex items-center justify-between">
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick("#hero");
            }}
            className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 cursor-pointer z-10"
            aria-label="Jennifer Siqueira Studio de Beleza"
          >
            <img
              src="https://public.readdy.ai/ai/img_res/8fc9fa8a-5b51-42e8-a68d-8e20b58b33f0.png"
              alt="Jennifer Siqueira Studio de Beleza"
              title="Jennifer Siqueira Studio de Beleza Blumenau"
              className="h-12 md:h-16 w-auto"
            />
          </a>

          <div className="hidden lg:flex items-center">
            {navLinks.map((link, i) => (
              <span key={link.href} className="flex items-center">
                {i > 0 && (
                  <span className="text-primary-500/50 mx-2 text-xs leading-none">
                    |
                  </span>
                )}
                <a
                  href={link.href}
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick(link.href);
                  }}
                  className="px-2 py-2 text-[13px] font-label uppercase tracking-[0.12em] text-background-100/80 hover:text-primary-300 transition-colors duration-300 whitespace-nowrap"
                >
                  {link.label}
                </a>
              </span>
            ))}
          </div>

          <div className="hidden lg:block">
            <a
              href="https://wa.me/5547991654435?text=Ol%C3%A1%20Jennifer%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio!"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 border border-primary-400/70 hover:bg-primary-500 hover:border-primary-500 text-primary-200 hover:text-background-950 px-6 py-2.5 rounded-md text-[13px] font-label uppercase tracking-[0.14em] transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
              Agende
            </a>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden ml-auto w-10 h-10 flex items-center justify-center text-background-50 cursor-pointer"
            aria-label="Menu"
          >
            <i
              className={`text-2xl transition-transform duration-300 ${
                mobileOpen ? "ri-close-line" : "ri-menu-line"
              }`}
            ></i>
          </button>
        </div>
      </nav>

      <div
        className={`fixed inset-0 z-30 lg:hidden transition-all duration-400 ${
          mobileOpen
            ? "opacity-100 pointer-events-auto"
            : "opacity-0 pointer-events-none"
        }`}
      >
        <div
          className="absolute inset-0 bg-background-950/60 backdrop-blur-sm"
          onClick={() => setMobileOpen(false)}
        />
        <div
          className={`absolute top-0 right-0 h-full w-72 bg-background-950 border-l border-primary-500/15 transition-transform duration-400 ${
            mobileOpen ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="flex flex-col pt-24 px-8 gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavClick(link.href);
                }}
                className="py-3 text-base font-heading text-background-100 hover:text-primary-300 transition-colors duration-300 border-b border-background-800/60 last:border-none"
              >
                {link.label}
              </a>
            ))}
            <div className="mt-6">
              <a
                href="https://wa.me/5547991654435?text=Ol%C3%A1%20Jennifer%2C%20gostaria%20de%20agendar%20um%20hor%C3%A1rio!"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 hover:bg-primary-600 text-background-950 px-8 py-3 rounded-md text-[13px] font-label uppercase tracking-[0.14em] transition-all duration-300 whitespace-nowrap w-full cursor-pointer"
              >
                Agendar Horário
                <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}